const setCSSVariables = (variables) => {
  const styleTag = document.createElement('style');
  styleTag.setAttribute('type', 'text/css');
  styleTag.setAttribute('id', 'x-theme-colors');
  styleTag.innerHTML = variables;
  document.querySelector('head').appendChild(styleTag);

  if (typeof variables === 'string') {
    const cssVars = variables.replace(':root{', '').replace('}', '').split(';').filter(Boolean);

    cssVars.forEach((cssVar) => {
      const [property, value] = cssVar.split(':');
      if (property && value) {
        const cleanProp = property.trim();
        const cleanVal = value.trim();
        document.documentElement.style.setProperty(cleanProp, cleanVal);

        if (cleanProp === '--color-primario') {
          document.documentElement.style.setProperty('--primary-color', cleanVal);
        } else if (cleanProp === '--color-secundario') {
          document.documentElement.style.setProperty('--secondary-color', cleanVal);
        }

        if (cleanProp === '--fuente-primaria') {
          document.body.style.fontFamily = cleanVal;
        }
      }
    });
  }
};

export default setCSSVariables;
